import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1130ee5c")

_pushScopeId("data-v-1130ee5c")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-layout" }),
  /*#__PURE__*/_createTextVNode(" Basic layout ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Create basic grid layout using columns. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-dark" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withId(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
})